import { Component, Input } from "@angular/core";
import { PopoverController } from "@ionic/angular";

@Component({
	selector: "app-widget-hide-from-dashboard-menu",
	template: `
		<div class="dashboard-widget-menu" role="menu">
			<button type="button" class="dashboard-widget-menu-item" role="menuitem" (click)="hide()">
				<span class="material-symbols-outlined material-symbols-outlined--size-24" aria-hidden="true">
					visibility_off
				</span>
				<span>{{ "WIDGET__HIDE_FROM_DASHBOARD" | transloco }}</span>
			</button>
		</div>
	`,
	styleUrls: ["./widget-dashboard-menu.scss"],
})
export class WidgetHideFromDashboardMenuComponent {
	constructor(private popoverController: PopoverController) {}

	@Input() onHide: () => void;

	hide = () => {
		this.onHide?.();
		this.popoverController.dismiss();
	};
}
